import {createSlice} from '@reduxjs/toolkit'
import {
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    ROUTE_PATH
} from "../../app/constants"

export const AGENT_SORT_TYPES = {
    FIRST_NAME : "firstName",
    LAST_NAME : "lastName",
    STATUS_VALUE : "status"
}

export const STATUS_BY_OPTIONS = {
    ALL : "all",
    DRAFT : "draft",
    SUBMITTED : "submitted",
    PENDING : "pending",
    APPROVED : "approved",
    DENIED : "denied",
    REVOKED : "revoked",
    WITHDRAWN : "withdrawn",
    SUSPENDED : "suspended",
    EXPIRED : "expired",
    PENDING_PAYMENT : "pending_payment"
}

export const ADDITIONAL_APPLICATION_TYPE_OPTIONS = {
    ALL : "all",
    BRANCHES: "branches",
    AGENTS: "agents"
}

const welcomeState = () => ({
    "collection-agency" : {
        header : "Your company name",
        dialog : { 
            header : "Welcome to collection licensing service",
            htmlText : "<span>The online service is available on April 1, 2021 and it looks we don't have your information on this service yet. Please click Continue to start your Collection Licence application.</span>",
            navigation : {
                next : ROUTE_PATH.RJSC_SEARCH
            }  
        },
        navigation : { 
            next : ROUTE_PATH.RJSC_SEARCH
        }
    },
    "debt-management-agency" : {
        header : "Your company name",
        dialog : { 
            header : "Welcome to debt management licensing service",
            htmlText : "<span>The online service is available on April 1, 2021 and it looks we don't have your information on this service yet. Please click Continue to start your Debt Management Licence application.</span>",
            navigation : {
                next : ROUTE_PATH.RJSC_SEARCH
            }  
        },
        navigation : { 
            next : ROUTE_PATH.RJSC_SEARCH
        } 
    },
    dialogDisplay: true,
    agentFilterOptions : [{
        id:AGENT_SORT_TYPES.FIRST_NAME,
        canShowOption: () => true,
        textStr: (additionalApplicationType, applicationType) => {
            if(applicationType === APPLICATION_TYPE_COLLECTION_AGENCY
                || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
                    //Only branch is applicable as collectors are removed
                // if(additionalApplicationType === ADDITIONAL_APPLICATION_TYPE_OPTIONS.ALL) {
                //     return "First name / Branch name"
                // } else if(additionalApplicationType === ADDITIONAL_APPLICATION_TYPE_OPTIONS.BRANCHES) {
                //     return "Branch name"
                // } else {
                //     return "First name"
                // }
                return "Branch name"
            } else {
                return "First name"
            }
        },
    }, { 
        id: AGENT_SORT_TYPES.LAST_NAME,
        canShowOption: (additionalApplicationType, applicationType) => {
            if (applicationType === APPLICATION_TYPE_COLLECTION_AGENCY
                || applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
                return false;
            }
            // if(additionalApplicationType === ADDITIONAL_APPLICATION_TYPE_OPTIONS.BRANCHES) {
            //     return false;
            // }
            return true;
        },
        textStr: () => "Last name",
    }, { 
        id : AGENT_SORT_TYPES.STATUS_VALUE,
        canShowOption: () => true,
        textStr: () => "Only show status",
    }],
    agentSort : AGENT_SORT_TYPES.FIRST_NAME,
    agentSubFilter : STATUS_BY_OPTIONS.ALL,
    additionalApplicationTypeFilter: ADDITIONAL_APPLICATION_TYPE_OPTIONS.ALL,
})


const welcomeSlice = createSlice({
    name: 'welcome',
    initialState : welcomeState(),
    reducers : {
        resetWelcomeDialogDisplay(state, action) { 
            state[action.payload].dialogDisplay = false
        },
        setAgentSort(state, action) { 
            state.agentSort = action.payload
        },
        setAgentSubFilter(state, action) { 
            state.agentSubFilter = action.payload
        },
        setAdditionalApplicationTypeFilter(state, action) {
            state.additionalApplicationTypeFilter = action.payload
        }
    }
})

export const {
    resetWelcomeDialogDisplay,
    setAgentSort,
    setAgentSubFilter,
    setAdditionalApplicationTypeFilter
} = welcomeSlice.actions

export default welcomeSlice.reducer